import * as React from 'react';

export const ConsoleTestsRunning: React.StatelessComponent<{}> = () => (
  <div className='tests-wrapper'>
    <div className='tests-running'>
      <span className='console-component--line-system'>Executing tests...</span>
    </div>
  </div>
);
